module.exports = __webpack_public_path__ + "media/images/player-cutout-big-placeholder-25b9a2f87f77b3568a1a15052c4707d6.png";